import instance from "@/services/api";

export const apartmentOwnersHistoryAPI = {
  async getList(client_request_id) {
    return await instance().get(`/client_request/${client_request_id}/grt_requests/client_history/read/`).then(res => res?.data)
  }
}